import { render, staticRenderFns } from "./RingChart.vue?vue&type=template&id=765e84f8&scoped=true"
import script from "./RingChart.vue?vue&type=script&lang=js"
export * from "./RingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e84f8",
  null
  
)

export default component.exports